import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NotificationItem, NotificationType } from '@data/schema/notificationitem';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    standalone: false
})
export class NotificationComponent implements OnInit, OnDestroy {
  private notificationSubscription: Subscription;
  notifications: NotificationItem[] = [];
  isDisplayed: boolean = false;
  readonly timeoutDuration: number = 10000;

  constructor(private notificationService: NotificationService, private router: Router) {}

  ngOnInit() {
    this.notificationSubscription = this.notificationService
      .getNotificationObs()
      .subscribe((notification: NotificationItem) => {
        this.notifications = [];
        if (!notification.disableTimeout) {
          this.notifications.push(notification);
          setTimeout(() => {
            this.notifications = this.notifications.filter(
              (item: NotificationItem) => item !== notification
            );
          }, this.timeoutDuration);
        } else {
          this.notifications.push(notification);
        }
        this.isDisplayed = true;
      });
    this.notificationService.flushNotificationObs().subscribe((data) => {
      this.notifications = [];
    });
    // To remove notifications on route change.
    this.router.events.subscribe(() => {
      this.notifications = this.notifications.filter(
        (notification) => notification.acrossRoutes === true
      );
    });
  }

  getAlertClass(message: NotificationItem) {
    if (!message) return "";
    const classes = ['notification'];
    const notificationTypeClasses = {
      [NotificationType.Success]: 'notification__success',
      [NotificationType.Error]: 'notification__error',
      [NotificationType.Warning]: 'notification__warning',
      [NotificationType.Info]: 'notification__info',
    };
    classes.push(notificationTypeClasses[message.messageType]);
    return classes.join(' ');
  }

  closeNotifications() {
    this.isDisplayed = false;
    this.notifications = [];
  }

  ngOnDestroy() {
    this.notificationSubscription.unsubscribe();
  }
}
